import StoreInterface from '../StoreInterface';
import CacheStore from './Cache/CacheStore';
import IDbStore from './IDB/IDbStore';

export default class IDbOrCacheStore implements StoreInterface {

    // store's identifier
    storeIdx = "BASE_";

    // underlying IDb reference
    store: any = undefined;

    supportsIdb = true;

    constructor(storeIdx?) {
        if (storeIdx)
            this.storeIdx = storeIdx;

        let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        if (!indexedDB) {
            console.log('Warning: IndexedDB is not supported, for store:', this.storeIdx);
            this.supportsIdb = false;
            this.store = new CacheStore(this.storeIdx);
        } else {
            this.store = new IDbStore(this.storeIdx);
        }
    }

    public async set(key, val) {
        return await this.store.set(key, val);
    }

    public async get(key, defaultValue?) {
        return await this.store.get(key, defaultValue);
    }

    public async remove(key) {
        return await this.store.remove(key);
    }

    public async getAll() {
        return await this.store.getAll();
    }

    public async getAllKeys() {
        return await this.store.getAllKeys();
    }

    public async size() {
        return await this.store.size();
    }

    public async clear() {
        return await this.store.clearAll();
    }

    public async clearAll() {
        return await this.clear();
    }

    public async clearIf(condition) {
        return await this.store.clearIf(condition);
    }

    public async printAll() {
        let d = await this.getAll();
    }

    public async onReady(cb) {
        this.store.onReady(cb);
    }

}
